import { render, staticRenderFns } from "./DistributeIpTable.vue?vue&type=template&id=2c4b72f4&"
import script from "./DistributeIpTable.vue?vue&type=script&lang=js&"
export * from "./DistributeIpTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports